export default __webpack_public_path__ + "static/avatar-kortical-team1--mobile-f73a3d5aa61339ce97b3376c233254e4.jpg";